import { render } from "./FilterAdd.vue?vue&type=template&id=60027746"
import script from "./FilterAdd.vue?vue&type=script&lang=js"
export * from "./FilterAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__